// src/views/contasContabeis/CopiarContasModal.jsx
import React, { useState } from "react";
import contasContabeisService from "../../services/contasContabeisService";

export default function CopiarContasModal({
  show, onClose, onCopiado, condominios=[], idCondominioAtual,
  notify, askConfirm,
}) {
  // Fallback inline para não quebrar se o pai não passar os helpers.
  const _notify = notify || ((t, m) => { if (t === "error") console.error(m); });
  const _askConfirm = askConfirm || (async (cfg) => window.confirm(cfg.mensagem));

  const [idOrigem, setIdOrigem]     = useState("");
  const [substituir, setSubstituir] = useState(false);
  const [preview, setPreview]       = useState(null);
  const [previewed, setPreviewed]   = useState(false);
  const [loading, setLoading]       = useState(false);
  const [copiando, setCopiando]     = useState(false);

  const reset = () => { setIdOrigem(""); setSubstituir(false); setPreview(null); setPreviewed(false); };

  const handlePreview = async () => {
    if (!idOrigem) return _notify("warning","Selecione o condomínio de origem.");
    setLoading(true);
    try {
      const r = await contasContabeisService.previewCopiar(idOrigem, idCondominioAtual);
      setPreview(r); setPreviewed(true);
    } catch(e) { _notify("error", e.message); }
    setLoading(false);
  };

  const handleCopiar = async () => {
    if (!previewed) return _notify("warning","Clique em Pré-visualizar primeiro.");
    const novas = preview?.novas || 0;
    const subst = substituir ? (preview?.existentes||0) : 0;
    if (novas===0 && subst===0) return _notify("info","Nada a copiar.");
    const ok = await _askConfirm({
      titulo: "Confirmar cópia",
      mensagem: `Confirmar cópia de ${novas} conta(s) nova(s)${subst>0?` e substituição de ${subst} existente(s)`:""}?`,
      textoOk: "Copiar",
    });
    if (!ok) return;
    setCopiando(true);
    try {
      const r = await contasContabeisService.copiar({ idOrigem, idDestino: idCondominioAtual, substituir });
      _notify("success", r.message);
      onCopiado && onCopiado();
      onClose(); reset();
    } catch(e) { _notify("error", e.message); }
    setCopiando(false);
  };

  if (!show) return null;

  const origemNome = condominios.find(c=>String(c.id)===String(idOrigem))?.nmFantasia || condominios.find(c=>String(c.id)===String(idOrigem))?.nmCondominio || "";
  const destinoNome = condominios.find(c=>String(c.id)===String(idCondominioAtual))?.nmFantasia || "";

  return (
    <div className="modal fade show d-block" style={{ background:"rgba(0,0,0,.55)" }} tabIndex="-1">
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <div className="d-flex align-items-center gap-3">
              <div style={{ width:38,height:38,background:"rgba(255,255,255,.15)",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center" }}>
                <i className="bi bi-copy" style={{ fontSize:18,color:"#fff" }}/>
              </div>
              <div>
                <h5 className="modal-title mb-0">Copiar Plano de Contas</h5>
                <small style={{ color:"rgba(255,255,255,.6)",fontSize:12 }}>Destino: {destinoNome}</small>
              </div>
            </div>
            <button className="btn-close btn-close-white" onClick={()=>{ onClose(); reset(); }}/>
          </div>

          <div className="modal-body">
            <div className="form-section">
              <div className="form-section-title"><i className="bi bi-sliders"/> Configuração</div>

              <div style={{ background:"var(--bg-highlight)",border:"1px solid #BFDBFE",borderRadius:8,padding:"10px 14px",fontSize:12.5,color:"var(--primary)",marginBottom:16 }}>
                <i className="bi bi-info-circle me-2"/>
                Copia o plano de contas de outro condomínio para <strong>{destinoNome}</strong>. Saldos não são copiados.
              </div>

              <div className="row g-3 align-items-end">
                <div className="col-md-6">
                  <label className="form-label">Condomínio de Origem <span className="required-mark">*</span></label>
                  <select className="form-select" value={idOrigem} onChange={e=>{ setIdOrigem(e.target.value); setPreviewed(false); setPreview(null); }}>
                    <option value="">— Selecione —</option>
                    {condominios.filter(c=>String(c.id)!==String(idCondominioAtual)).map(c=>(
                      <option key={c.id} value={c.id}>{c.nmFantasia||c.nmCondominio}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4 d-flex align-items-center gap-2 pb-1">
                  <div className="form-check form-switch mb-0">
                    <input className="form-check-input" type="checkbox" id="substituir" checked={substituir} onChange={e=>setSubstituir(e.target.checked)}/>
                    <label className="form-check-label" htmlFor="substituir" style={{ fontSize:13,fontWeight:500,color:"var(--gray-600)" }}>
                      Substituir existentes
                    </label>
                  </div>
                </div>
                <div className="col-md-2">
                  <button className="btn btn-primary w-100" onClick={handlePreview} disabled={loading||!idOrigem}>
                    {loading?<span className="spinner-border spinner-border-sm"/>:<><i className="bi bi-eye"/> Prévia</>}
                  </button>
                </div>
              </div>
            </div>

            {previewed && preview && (
              <div className="form-section">
                <div className="form-section-title d-flex justify-content-between align-items-center">
                  <span><i className="bi bi-table"/> Pré-visualização — {origemNome} → {destinoNome}</span>
                  <div className="d-flex gap-2">
                    <span style={{ background:"var(--bg-success-soft)",color:"#166534",padding:"2px 10px",borderRadius:12,fontSize:12,fontWeight:600 }}>{preview.novas} novas</span>
                    {preview.existentes>0&&(
                      <span style={{ background: substituir?"#FEF9C3":"var(--gray-100)", color:substituir?"#854D0E":"var(--gray-400)",padding:"2px 10px",borderRadius:12,fontSize:12,fontWeight:600 }}>
                        {preview.existentes} já existem {substituir?"(serão substituídas)":"(serão ignoradas)"}
                      </span>
                    )}
                  </div>
                </div>
                <div style={{ maxHeight:300,overflowY:"auto" }}>
                  <table className="table table-custom">
                    <thead><tr><th>Classificação</th><th>Descrição</th><th>Situação</th></tr></thead>
                    <tbody>
                      {preview.data?.map((c,i)=>(
                        <tr key={i} style={{ opacity:c.situacao==="existente"&&!substituir?.6:1 }}>
                          <td style={{ fontFamily:"monospace",fontWeight:700,color:"var(--primary)" }}>{c.classificacaoContabil}</td>
                          <td style={{ fontSize:13 }}>{c.descConta}</td>
                          <td>
                            {c.situacao==="nova"
                              ? <span style={{ background:"var(--bg-success-soft)",color:"#166534",padding:"2px 8px",borderRadius:12,fontSize:11,fontWeight:600 }}>✓ Nova</span>
                              : <span style={{ background:substituir?"#FEF9C3":"var(--gray-100)",color:substituir?"#854D0E":"var(--gray-400)",padding:"2px 8px",borderRadius:12,fontSize:11,fontWeight:600 }}>
                                  {substituir?"↺ Substituir":"= Ignorar"}
                                </span>
                            }
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>

          <div className="modal-footer d-flex justify-content-between">
            <div style={{ fontSize:12,color:"var(--gray-400)" }}>
              {previewed && preview && <span><strong style={{ color:"var(--primary)" }}>{substituir?(preview.novas+(preview.existentes||0)):preview.novas}</strong> conta(s) serão processadas</span>}
            </div>
            <div className="d-flex gap-2">
              <button className="btn btn-outline-secondary" onClick={()=>{ onClose(); reset(); }}><i className="bi bi-x-circle"/> Cancelar</button>
              <button className="btn btn-success" onClick={handleCopiar} disabled={!previewed||copiando||(preview?.novas===0&&(!substituir||preview?.existentes===0))}>
                {copiando?<><span className="spinner-border spinner-border-sm me-2"/>Copiando...</>:<><i className="bi bi-copy"/> Confirmar Cópia</>}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
